import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { jsx as _jsx } from "react/jsx-runtime";
const LoadingComponent = () => /*#__PURE__*/_jsx(TFlex, {
  justify: "start",
  position: "relative",
  children: /*#__PURE__*/_jsx(LoadingSpinner, {
    size: "xs"
  })
});
LoadingComponent.displayName = 'LoadingComponent';
export function makeAsyncTitle({
  loader
}) {
  return Loadable({
    loader,
    LoadingComponent
  });
}